import { render, staticRenderFns } from "./download.vue?vue&type=template&id=a080333c&scoped=true&"
import script from "./download.vue?vue&type=script&lang=ts&"
export * from "./download.vue?vue&type=script&lang=ts&"
import style0 from "./download.vue?vue&type=style&index=0&id=a080333c&prod&lang=less&scoped=true&"
import style1 from "./download.vue?vue&type=style&index=1&id=a080333c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a080333c",
  null
  
)

export default component.exports